// @ts-nocheck
import { takeLatest, call, put } from 'redux-saga/effects';
import router from 'components/Router';
import * as types from 'appRedux/actions/login';
import { loginUser } from 'appRedux/services/auth';
import {
  successToast,
  errorToast,
  infoToast,
  dismissToast,
} from 'utils/toastHandler';

function* loginRequest(action) {
  try {
    const { payload } = action;
    const { data } = yield call(loginUser, payload);

    yield put({ type: types.USER_LOGIN_SUCCESS, payload: data });
    router.navigate('/');
    dismissToast();
  } catch (error) {
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* logoutUser(action) {
  const {
    payload: { type },
  } = action;
  const user = localStorage.getItem('user');
  localStorage.clear();
  if (user) {
    localStorage.setItem('user', user);
  }

  yield put({ type: types.LOGOUT_USER_SUCCESS });
  router.navigate('/login');
  if (type === 'auto') {
    infoToast('Your session has expired, please login again.', false);
  } else {
    successToast('You logged out successfully.');
  }
}

function* loginWatcher() {
  yield takeLatest(types.USER_LOGIN_REQUEST, loginRequest);
  yield takeLatest(types.LOGOUT_USER_REQUEST, logoutUser);
}

export default loginWatcher;
